import type { Application, HoBankingPatch, HoFields } from "../types";

export function hoBankingPatchHasChanges(patch: HoBankingPatch): boolean {
  return (
    Object.prototype.hasOwnProperty.call(patch, "iciciAccountNumber") ||
    Object.prototype.hasOwnProperty.call(patch, "iciciIfsc") ||
    Object.prototype.hasOwnProperty.call(patch, "iciciBranch") ||
    (Array.isArray(patch.mouFilesUpload) && patch.mouFilesUpload.length > 0) ||
    (Array.isArray(patch.mouRemovedAttachmentIds) && patch.mouRemovedAttachmentIds.length > 0)
  );
}

export type HoBankingCheck = {
  iciciAccount: boolean;
  iciciIfsc: boolean;
  iciciBranch: boolean;
  iciciComplete: boolean;
  mouAttached: boolean;
};

/** What the pipeline checks for ICICI + MOU (see `deriveApplicationStatus`). */
export function hoBankingChecks(ho: HoFields): HoBankingCheck {
  const iciciAccount = Boolean(ho.iciciAccountNumber.trim());
  const iciciIfsc = Boolean(ho.iciciIfsc.trim());
  const iciciBranch = Boolean(ho.iciciBranch.trim());
  const mouAttached =
    Boolean(ho.mouFileName) ||
    Boolean(ho.mouFileStored) ||
    (Array.isArray(ho.mouAttachments) && ho.mouAttachments.length > 0) ||
    (Array.isArray(ho.mouFilesUpload) && ho.mouFilesUpload.length > 0);
  return {
    iciciAccount,
    iciciIfsc,
    iciciBranch,
    iciciComplete: iciciAccount && iciciIfsc && iciciBranch,
    mouAttached,
  };
}

/** Plain label for why status is still `ready_for_icici` or `ready_for_mou`. */
export function hoBankingStatusHint(app: Application): string | null {
  if (app.status !== "ready_for_icici" && app.status !== "ready_for_mou") return null;
  const c = hoBankingChecks(app.ho);
  if (app.status === "ready_for_icici") {
    const missing: string[] = [];
    if (!c.iciciAccount) missing.push("ICICI account number");
    if (!c.iciciIfsc) missing.push("ICICI IFSC");
    if (!c.iciciBranch) missing.push("ICICI branch");
    if (!missing.length) return null;
    return `Still needed for this step: ${missing.join(", ")}. MOU can be added in the same tab but does not replace these fields.`;
  }
  if (!c.mouAttached) {
    return "ICICI account, IFSC, and branch are saved. Upload the signed MOU and press Save banking & MOU.";
  }
  return null;
}
